import CategoryView from '@/pages/category/CategoryView';
import TradingFlow from '@/pages/forex-trading/components/TradingFlow';
import OrderTypeGuide from '@/pages/forex-trading/components/OrderTypeGuide';
import ExecutionCostGuide from '@/pages/forex-trading/components/ExecutionCostGuide';
import PositionSizeCalculator from '@/pages/forex-trading/components/PositionSizeCalculator';
import MarketSessions from '@/pages/forex-trading/components/MarketSessions';
import ExecutionMistakes from '@/pages/forex-trading/components/ExecutionMistakes';
import PreTradeChecklist from '@/pages/forex-trading/components/PreTradeChecklist';
import BrokerRecommendation from '@/pages/forex-trading/components/BrokerRecommendation';
import BrokerDetails from '@/pages/forex-trading/components/BrokerDetails';

export default function ForexTrading() {
  return (
    <CategoryView
      categorySlug="forex-trading"
      beforeArticles={<TradingFlow />}
      articlesLast
      afterArticles={
        <>
          <OrderTypeGuide />
          <ExecutionCostGuide />
          <PositionSizeCalculator />
          <MarketSessions />
          <ExecutionMistakes />
          <PreTradeChecklist />
          <BrokerRecommendation />
          <BrokerDetails />
        </>
      }
    />
  );
}